const theme = {
    state: {
        dark: localStorage.getItem('dark-theme') == 'true' ? true : false,
    },
    mutations: {
        SWITCH(state) {
            localStorage.setItem('dark-theme', !state.dark)

            state.dark = !state.dark
        },
    },
    actions: {
        changeTheme: ({
            commit
        }) => {
            commit('SWITCH')
        }
    },
    getters: {
        theme: state => state.dark
    }
}

export default theme